import { api, transformApiResponse } from "./BaseApi";
import { ExamTemplateIndex } from "../../model/Exam";

const getExamUrl = (id?: string) => "/Exam" + (id === undefined ? "" : `/${id}`);

const examsApi = api.enhanceEndpoints({ addTagTypes: ["Exams"] }).injectEndpoints({
  endpoints: (builder) => ({
    getPublishedExams: builder.query<ExamTemplateIndex[], void>({
      // Keep cache for 1 second ("disable") until all exam APIs will be migrated to RTK Query.
      keepUnusedDataFor: 1,
      query: () => `${getExamUrl()}/published`,
      transformResponse: transformApiResponse,
      providesTags: (result) =>
        result
          ? [...result.map(({ id }) => ({ type: "Exams" as const, id })), { type: "Exams", id: "PUBLISHED_LIST" }]
          : [{ type: "Exams", id: "PUBLISHED_LIST" }],
    }),
  }),
});

export const { endpoints, useGetPublishedExamsQuery } = examsApi;
